import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Container,
  Grid,
  TextField,
  Typography,
  Paper,
  Divider,
} from "@mui/material";
import GoogleIcon from "@mui/icons-material/Google";
import Div from "@jumbo/shared/Div";
import { Card, CardContent, Link } from "@mui/material";
import { useAppMutation } from "../../../services";
import parentServices from "../../../services/parent-services";
import { useTranslation } from "react-i18next";
import {
  GoogleReCaptchaProvider,
  useGoogleReCaptcha,
} from "react-google-recaptcha-v3";
import { useLocation, useNavigate } from "react-router-dom";
import { getAssetPath } from "../../../utils/appHelpers";
import { ASSET_IMAGES } from "../../../utils/constants/paths";
import moment from "moment/moment";
import StepParent from "./parent";
import StepStudent from "./student";

const Signup = () => {
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.REACT_APP_CAPTCHA_SITE_KEY}
    >
      <InnerSignup />
    </GoogleReCaptchaProvider>
  );
};

const InnerSignup = () => {
  const {
    mutate: signUp,
    error,
    isError,
    isLoading,
    data: result,
    isSuccess,
  } = useAppMutation(parentServices.signUpNew);
  const { t } = useTranslation();
  const [errStudentMsg, setErrStudentMsg] = React.useState("");
  const [errParentMsg, setErrParentMsg] = React.useState("");
  const { executeRecaptcha } = useGoogleReCaptcha();
  const navigate = useNavigate();
  const location = useLocation();
  const [signupType, setSignupType] = useState();
  const [step, setStep] = React.useState(1);

  const [selectedChildIndex, setSelectedChildIndex] = React.useState(0);

  const [childValues, setChildValues] = React.useState([
    {
      firstName: "",
      lastName: "",
      dateOfBirth: null,
      startDate: null,
      startTime: null,
      gender: "",
    },
  ]);

  React.useEffect(() => {
    console.log(location.pathname);

    if (
      location.pathname === "/parent/signup" ||
      location.pathname === "/parent/signup-1"
    ) {
      setSignupType("parent-first");
    } else if (location.pathname === "/parent/signup-2") {
      setSignupType("student-first");
    }
  }, [location]);

  console.log(signupType);

  useEffect(() => {
    if (isSuccess) {
      window.dataLayer = window.dataLayer || [];
      const { email, firstName, lastName, phone, country } = values;
      const { code, countryCode, label } = country;
      console.log(values);
      window.dataLayer.push({
        event: "ParentSignUp",
        parentEmail: email,
        parentFirstName: firstName,
        parentLastName: lastName,
        parentPhone: phone,
        parentCountry: label,
      });
      navigate("/parent/signup/success");
    }
    if (isError && error) {
      const msg = error.message || error || '';
      if (msg && msg.includes("User Already Exists")) {
        setErrParentMsg(t("parent-signup.title.alreadyEmailMsg"));

        if (signupType === "student-first") {
        } else if (signupType === "parent-first") {
          setStep(1);
        }
        setTimeout(() => {
          setErrParentMsg("");
        }, 3000);
      } else {
        if (signupType === "student-first") {
          setErrParentMsg(t("parent-signup.title.signUpErrorMsg"));
        } else if (signupType === "parent-first") {
          setErrStudentMsg(t("parent-signup.title.signUpErrorMsg"));
        }

        setTimeout(() => {
          setErrParentMsg("");
          setErrStudentMsg("");
        }, 3000);
      }
    }
    console.log(
      "Signup-----------------------",
      isError,
      error,
      isSuccess,
      result,
    );
  }, [result, isSuccess, isError, navigate, error, t]);

  const [values, setValues] = React.useState({
    email: "",
    firstName: "",
    lastName: "",
    password: "",
    country: {
      countryCode: "FR",
      label: "France",
      code: "33",
      suggested: true,
    },
    phone: "",
    showPassword: false,
    subscribeNewsLetter: false,
    terms: false,
  });

  const handleChildChange0 = (prop) => (event) => {
    setChildValues({ ...childValues, [prop]: event.target.value });
  };

  const handleChildChange = (index, field, value) => {
    setChildValues((prev) => {
      const updated = [...prev];
      updated[index][field] = value;
      return updated;
    });
  };

  const setFormStep = () => {
    if (signupType === "student-first") {
      if (step === 1) {
        validateStudentForm();
      } else {
        const fullPhoneNumber = `+${values.country.code}${values.phone}`;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const fullNumberRegex =
          /^[\+]?[(]?[0-9]{1,4}[)]?[-\s\.]?[0-9]{3,}[-\s\.]?[0-9]{4,6}$/im;

        if (!emailRegex.test(values.email)) {
          setErrParentMsg("Enter a valid email address");
          return setTimeout(() => setErrParentMsg(""), 3000);
        }
        if (
          !values.email ||
          !values.firstName ||
          !values.lastName ||
          !values.password ||
          !values.country ||
          !values.phone
        ) {
          setErrParentMsg(t("parent-signup.title.requiredFieldErrorMsg"));
          return setTimeout(() => setErrParentMsg(""), 3000);
        }
        if (!values.terms) {
          setErrParentMsg(t("parent-signup.title.termsErrorMsg"));
          return setTimeout(() => setErrParentMsg(""), 3000);
        }
        if (!fullNumberRegex.test(fullPhoneNumber.replace(/\s/g, ""))) {
          setErrParentMsg("Invalid Full Phone Number");
          return setTimeout(() => setErrParentMsg(""), 3000);
        }
        handleFinalSignup();
      }
    } else if (signupType === "parent-first") {
      if (step === 1) {
        validateParentForm();
      } else {
        const child = childValues[selectedChildIndex];
        console.log("Child:", child);
        const startDate = moment(child.startDate).format("YYYY-MM-DD");
        const startTime = child.startTime;
        const selectedStartDateTime = new Date(`${startDate}T${startTime}`);
        const selectedEndDateTime = new Date(`${startDate}T${startTime}`);
        selectedEndDateTime.setMinutes(selectedEndDateTime.getMinutes() + 30);

        child.startDate = selectedStartDateTime;
        child.endDate = selectedEndDateTime;

        if (!child.firstName || child.firstName.trim() === "") {
          setErrStudentMsg("First name is required");
          return setTimeout(() => setErrStudentMsg(""), 3000);
        }

        if (!child.lastName || child.lastName.trim() === "") {
          setErrStudentMsg("Last name is required");
          return setTimeout(() => setErrStudentMsg(""), 3000);
        }

        if (!child.dateOfBirth) {
          setErrStudentMsg("Date of Birth is required");
          return setTimeout(() => setErrStudentMsg(""), 3000);
        }

        if (!child.gender || child.gender.trim() === "") {
          setErrStudentMsg("Gender is required");
          return setTimeout(() => setErrStudentMsg(""), 3000);
        }

        if (!child.startDate) {
          setErrStudentMsg("Start date is required");
          return setTimeout(() => setErrStudentMsg(""), 3000);
        }

        if (!child.startTime) {
          setErrStudentMsg("Start time is required");
          return setTimeout(() => setErrStudentMsg(""), 3000);
        }
        handleFinalSignup();
      }
    }
  };

  const validateParentForm = () => {
    const fullPhoneNumber = `+${values.country.code}${values.phone}`;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const fullNumberRegex =
      /^[\+]?[(]?[0-9]{1,4}[)]?[-\s\.]?[0-9]{3,}[-\s\.]?[0-9]{4,6}$/im;

    if (!emailRegex.test(values.email)) {
      setErrParentMsg("Enter a valid email address");
      return setTimeout(() => setErrParentMsg(""), 3000);
    }
    if (
      !values.email ||
      !values.firstName ||
      !values.lastName ||
      !values.password ||
      !values.country ||
      !values.phone
    ) {
      setErrParentMsg(t("parent-signup.title.requiredFieldErrorMsg"));
      return setTimeout(() => setErrParentMsg(""), 3000);
    }
    if (!values.terms) {
      setErrParentMsg(t("parent-signup.title.termsErrorMsg"));
      return setTimeout(() => setErrParentMsg(""), 3000);
    }
    if (!fullNumberRegex.test(fullPhoneNumber.replace(/\s/g, ""))) {
      setErrParentMsg("Invalid Full Phone Number");
      return setTimeout(() => setErrParentMsg(""), 3000);
    }

    if (signupType === "parent-first") {
      setStep(2);
    } else if (signupType === "student-first") {
      handleFinalSignup();
    }
  };

  const validateStudentForm = () => {
    const child = childValues[selectedChildIndex];
    console.log("Child:", child);
    const startDate = moment(child.startDate).format("YYYY-MM-DD");
    const startTime = child.startTime;
    const selectedStartDateTime = new Date(`${startDate}T${startTime}`);
    const selectedEndDateTime = new Date(`${startDate}T${startTime}`);
    selectedEndDateTime.setMinutes(selectedEndDateTime.getMinutes() + 30);

    child.startDate = selectedStartDateTime;
    child.endDate = selectedEndDateTime;

    if (!child.firstName || child.firstName.trim() === "") {
      setErrStudentMsg("First name is required");
      return setTimeout(() => setErrStudentMsg(""), 3000);
    }

    if (!child.lastName || child.lastName.trim() === "") {
      setErrStudentMsg("Last name is required");
      return setTimeout(() => setErrStudentMsg(""), 3000);
    }

    if (!child.dateOfBirth) {
      setErrStudentMsg("Date of Birth is required");
      return setTimeout(() => setErrStudentMsg(""), 3000);
    }

    if (!child.gender || child.gender.trim() === "") {
      setErrStudentMsg("Gender is required");
      return setTimeout(() => setErrStudentMsg(""), 3000);
    }

    if (!child.startDate) {
      setErrStudentMsg("Start date is required");
      return setTimeout(() => setErrStudentMsg(""), 3000);
    }

    if (!child.startTime) {
      setErrStudentMsg("Start time is required");
      return setTimeout(() => setErrStudentMsg(""), 3000);
    }

    if (signupType === "parent-first") {
      handleFinalSignup();
    } else if (signupType === "student-first") {
      setStep(2);
    }
  };
  const handleFinalSignup = () => {
    const merged = { ...values, childInfo: childValues };
    console.log("Final Signup Payload:", merged);
    handleSignup(merged);
  };

  const handleSignup = (formValues = values) => {
    if (!executeRecaptcha) {
      console.log("Execute recaptcha not yet available");
      return;
    }

    const fullPhoneNumber = `+${formValues.country.code}${formValues.phone}`;
    executeRecaptcha("parentSigunForm").then((gReCaptchaToken) => {
      const obj = {
        ...formValues,
        location: { country: formValues.country.code },
        phone: {
          fullNumber: fullPhoneNumber.replace(/\s/g, ""),
          code: formValues.country.code,
          number: formValues.phone,
        },
        token: gReCaptchaToken,
      };
      signUp(obj);
    });
  };

  if (location.pathname === "/parent/signup/success" || isSuccess) {
    return (
      <Div
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: 700,
        }}
      >
        <Card sx={{ padding: 3, width: 600, height: 280 }}>
          <CardContent sx={{ textAlign: "center" }}>
            <img src="/images/logos/logo.png" alt="Logo" width="150" />
            <Typography variant="h4" color="success" fontWeight={500} mb={2}>
              {t("parent-signup.title.successMsg")}
            </Typography>
            <Div
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                src="/images/logos/success2.png"
                alt="Success"
                width="50"
                style={{ marginBottom: "10px" }}
              />
              <Typography variant="body1" mb={0} mr={3}>
                {t("parent-signup.title.clickTo")}
                <Link
                  href="/parent/login"
                  color="inherit"
                  underline="none"
                  sx={{
                    "&:hover": { color: "#ff8933" },
                    textDecoration: "underline",
                    ml: 0.5,
                  }}
                >
                  {t("parent-signup.title.login")}
                </Link>
              </Typography>
            </Div>
          </CardContent>
        </Card>
      </Div>
    );
  }

  const handleBack = () => {
    setStep(step - 1);
  };

  const StepIndicator = ({ currentStep, totalSteps }) => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginBottom: "1rem",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          {Array.from({ length: totalSteps }).map((_, index) => {
            const stepNumber = index + 1;
            const isActive = stepNumber === currentStep;
            const isCompleted = stepNumber < currentStep;

            return (
              <React.Fragment key={stepNumber}>
                <div
                  style={{
                    width: 28,
                    height: 28,
                    borderRadius: "50%",
                    backgroundColor: isActive
                      ? "#2d6bbf"
                      : isCompleted
                        ? "#e4e4e5"
                        : "#ddd",
                    color: isActive || isCompleted ? "white" : "#666",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "bold",
                  }}
                >
                  {stepNumber}
                </div>
                {stepNumber < totalSteps && (
                  <div
                    style={{
                      width: 40,
                      height: 2,
                      backgroundColor: isCompleted ? "green" : "#ddd",
                    }}
                  />
                )}
              </React.Fragment>
            );
          })}
        </div>
      </div>
    );
  };

  const renderTabs = () => {
    if (signupType === "parent-first") {
      if (step === 1) {
        return (
          <StepParent
            errMsg={errParentMsg}
            values={values}
            setValues={setValues}
            setStep={setFormStep}
            isLoading={isLoading}
            StepIndicator={<StepIndicator currentStep={step} totalSteps={2} />}
          />
        );
      } else {
        return (
          <StepStudent
            selectedChildIndex={selectedChildIndex}
            errMsg={errStudentMsg}
            handleBack={handleBack}
            childValues={childValues}
            handleChildChange={handleChildChange}
            setStep={setFormStep}
            isLoading={isLoading}
            StepIndicator={<StepIndicator currentStep={step} totalSteps={2} />}
          />
        );
      }
    } else if (signupType === "student-first") {
      if (step === 1) {
        return (
          <StepStudent
            selectedChildIndex={selectedChildIndex}
            errMsg={errStudentMsg}
            childValues={childValues}
            handleChildChange={handleChildChange}
            setStep={setFormStep}
            isLoading={isLoading}
          />
        );
      } else {
        return (
          <StepParent
            handleBack={handleBack}
            errMsg={errParentMsg}
            values={values}
            setValues={setValues}
            setStep={setFormStep}
            isLoading={isLoading}
          />
        );
      }
    }
  };

  return (
    <Box
      sx={{
        backgroundColor: "#002465", // 🔥 fallback background color
        //backgroundImage: `url("https://cdn.novakidschool.com/signup/redesign/redesign-main-bg.webp")`,
        //backgroundSize: "cover",
        //backgroundRepeat: "no-repeat",
        //backgroundPosition: "center",
        color: "#fff",
        minHeight: { xs: "auto", md: "100vh" }, // ✅ Full height only on desktops
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        py: { xs: 4, md: 8 },
      }}
    >
      <Container
        maxWidth={false} // ✅ Full width container
        sx={{
          px: { xs: 2, md: 6 }, // Less padding on mobile, more on desktop
        }}
      >
        <Grid
          container
          spacing={{ xs: 2, md: 4 }} // Smaller spacing on mobile
          //alignItems="center"
          justifyContent="space-between"
        >
          {/* Left Section */}
          <Grid item xs={12} md={5} lg={6}>
            <Box sx={{ textAlign: "center", mb: 2 }}>
              <img
                src="/images/widgets/NewSignUp.png"
                alt="Logo"
                style={{ width: "30%" }} // ✅ Responsive image
                //style={{ maxWidth: "100%", height: "auto" }} //
              />
            </Box>

            <Typography
              variant="h4"
              sx={{
                fontFamily: "Paytone One, sans-serif",
                fontWeight: 400,
                mb: 3,
                lineHeight: 1.2,
                width: "100%",
                color: "#fff",
                textAlign: "center",
                fontSize: { xs: "1.7rem", sm: "2rem", md: "2.5rem" }, // ✅ Responsive font
              }}
            >
              <Box component="span" sx={{ color: "#FFD600" }}>
                Votre session découverte
                <br />
                est offerte !
              </Box>
            </Typography>

            <Box sx={{ display: { xs: "none", md: "block" } }}>
              <Box sx={{ mt: 3, display: "flex", justifyContent: "center" }}>
                <Box>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                    <Typography component="span" sx={{ mr: 1 }}>
                      ✅
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ fontFamily: "'Lexend', sans-serif" }}
                    >
                      Un entretien individuel de 25 minutes
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                    <Typography component="span" sx={{ mr: 1 }}>
                      ✅
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ fontFamily: "'Lexend', sans-serif" }}
                    >
                      Une analyse à 360° de votre enfant
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                    <Typography component="span" sx={{ mr: 1 }}>
                      ✅
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ fontFamily: "'Lexend', sans-serif" }}
                    >
                      Des conseils clairs et personnalisés
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                    <Typography component="span" sx={{ mr: 1 }}>
                      ✅
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ fontFamily: "'Lexend', sans-serif" }}
                    >
                      La construction de son parcours sur mesure
                    </Typography>
                  </Box>
                </Box>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mt: 2,
                  mb: 2,
                }}
              >
                <Typography
                  sx={{
                    color: "#FFF",
                    textAlign: "center",
                    fontFamily: "'Lexend', sans-serif",
                  }}
                >
                  {" "}
                  🚀 L’aventure HiPe Kids commence ici :
                  <br />
                  vers la confiance, la fluidité et la réussite !
                </Typography>{" "}
              </Box>

              <Box sx={{ mt: 4 }}>
                <Typography
                  sx={{
                    textAlign: "center",
                    fontSize: { xs: "0.75rem", sm: "0.85rem" },
                    fontFamily: "'Lexend', sans-serif",
                  }}
                  variant="body2"
                >
                  Ce site est protégé par reCAPTCHA.
                </Typography>
              </Box>
            </Box>
          </Grid>

          {/* Right Section */}
          <Grid item xs={12} md={5} lg={6}>
            {renderTabs()}
            <Box
              sx={{
                display: { xs: "block", md: "none" }, // visible only on xs/small screens
                mt: 3,
                textAlign: "center",
              }}
            >
              {/* Feature List */}
              <Box sx={{ mb: 2 }}>
                {[
                  "Un entretien individuel de 25 minutes",
                  "Une analyse à 360° de votre enfant",
                  "Des conseils clairs et personnalisés",
                  "La construction de son parcours sur mesure",
                ].map((text, idx) => (
                  <Box
                    key={idx}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      mb: 1,
                    }}
                  >
                    <Typography component="span" sx={{ mr: 1 }}>
                      ✅
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ fontFamily: "'Lexend', sans-serif" }}
                    >
                      {text}
                    </Typography>
                  </Box>
                ))}
              </Box>

              {/* Tagline */}
              <Typography
                sx={{
                  color: "#FFF",
                  mb: 2,
                  fontFamily: "'Lexend', sans-serif",
                }}
              >
                🚀 L’aventure HiPe Kids commence ici :
                <br />
                vers la confiance, la fluidité et la réussite !
              </Typography>

              {/* reCAPTCHA notice */}
              <Typography
                sx={{ fontSize: "0.75rem", fontFamily: "'Lexend', sans-serif" }}
                variant="body2"
              >
                Ce site est protégé par reCAPTCHA.
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Signup;
